import React from 'react'
import Banner from './Banner'

const Dashboard = () => {
    return (
        <>
            <main className='mt-5 pt-5'>
                <Banner />
            </main>
        </>
    )
}

export default Dashboard
